var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import InputWrapper from './input-wrapper';
var TextArea = forwardRef(function Input(_a, ref) {
    var id = _a.id, label = _a.label, required = _a.required, errorMessage = _a.errorMessage, props = __rest(_a, ["id", "label", "required", "errorMessage"]);
    return (_jsx(InputWrapper, { label: label, id: id, errorMessage: errorMessage, required: required, children: _jsx("textarea", __assign({}, props, { required: required, className: "form-control", id: id, ref: ref })) }));
});
export default TextArea;
